import {
  Children,
  cloneElement,
  HTMLAttributes,
  isValidElement,
  ReactNode,
} from "react";

interface GridProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  firstChildClassName?: string;
  lastChildClassName?: string;
  middleChildClassName?: string;
}

export const Grid = ({
  children,
  className,
  firstChildClassName = "",
  lastChildClassName = "",
  middleChildClassName = "",
  ...rest
}: GridProps) => {
  const ChildrenArray = Children.toArray(children);
  return (
    <>
      {ChildrenArray.map((child, index) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ...rest,
            className: `${child.props.className ?? ""} ${className} ${
              index === 0 ? firstChildClassName : ""
            } ${index === ChildrenArray.length - 1 ? lastChildClassName : ""} ${
              index !== 0 && index !== ChildrenArray.length - 1
                ? middleChildClassName
                : ""
            }
            `,
          });
        }
        return child;
      })}
    </>
  );
};

interface GridHeaderProps {
  children: ReactNode;
}

const GridHeader = ({ children }: GridHeaderProps) => (
  <Grid
    className="py-2 px-4 text-sm font-bold text-brand border-b border-brand"
    firstChildClassName="text-left"
    middleChildClassName="text-right"
    lastChildClassName="text-right"
  >
    {children}
  </Grid>
);
Grid.Header = GridHeader;

const GridRow = ({ children, onClick, className, ...rest }: GridProps) => (
  <Grid
    firstChildClassName="text-left"
    middleChildClassName="text-right"
    lastChildClassName="text-right"
    onClick={onClick}
    className={
      (className ? className : "") + (onClick ? " cursor-pointer" : "")
    }
    {...rest}
  >
    {children}
  </Grid>
);
Grid.Row = GridRow;
